import styled from '@emotion/styled';
import { spacing, breakpoints } from '@naf/theme';
import { GridCol } from '@naf/grid';

export const StyledGridCol = styled(GridCol)`
  @media (min-width: ${breakpoints.m}) {
    margin-right: ${spacing.space64};
  }
`;
